"use client";

import { c as _c } from "react/compiler-runtime";
import { addWeeks } from "date-fns";
import { useMemo } from "react";
import { BusRequest } from "@/types/busrequest";
import MapContainer from "@/app/[lng]/_components/map/map-container";
import { useFilteredBusrequests } from "@/app/[lng]/(mainPages)/buspartner/_components/use-filtered-busrequests";
import { MarkerType } from "@/components/Util/Map/Map";
import { cn } from "@/lib/utils";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MdFilterAlt } from "react-icons/md";
import { BusRequestFilterSideBar } from "./busrequest-filter-sidebar";
import { useBusrequestMapContext } from "./busrequestmap-context";
function filterBusRequestsByDate(requests: BusRequest[], startTime: number, endTime: number): BusRequest[] {
  const filteredBusRequests: BusRequest[] = requests.filter(request => request.start.date < endTime && request.start.date > startTime || request.end.date > startTime && request.end.date < endTime || request.start.date < startTime && request.end.date > endTime && request.category !== "grouprequest");
  return filteredBusRequests;
}
export function BusRequestMap(t0) {
  const $ = _c(19);
  const {
    openModal,
    className
  } = t0;
  const visibleRequests = useFilteredBusrequests();
  const {
    amountFilterApplied
  } = useBusrequestMapContext();
  const limitByDate = false;
  let t1;
  if ($[0] !== visibleRequests) {
    t1 = false ? filterBusRequestsByDate(visibleRequests, new Date().valueOf(), addWeeks(new Date(), 2).getTime()) : visibleRequests;
    $[0] = visibleRequests;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mapItems = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("h-full", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== mapItems || $[5] !== openModal || $[6] !== t2) {
    t3 = <MapContainer showClusterModal={openModal} visibleItems={mapItems} type={MarkerType.BusRequest} className="h-[600px]" height="100%" containerClassName={t2} searchFieldClassName="locFF1" />;
    $[4] = mapItems;
    $[5] = openModal;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MdFilterAlt className="h-full w-full" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== amountFilterApplied) {
    t5 = amountFilterApplied > 0 && <div className="absolute -right-2 -top-2 h-5 w-5 content-center rounded-full bg-secondary text-center text-xs leading-none text-white">{amountFilterApplied}</div>;
    $[9] = amountFilterApplied;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <DropdownMenuTrigger className="absolute left-4 top-4 h-12 w-12 rounded-xl border-2 border-solid bg-babyBlue text-secondary">{t4}{t5}</DropdownMenuTrigger>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DropdownMenuContent className="rounded-xl border-2 border-solid border-secondary bg-babyBlue p-4"><BusRequestFilterSideBar /></DropdownMenuContent>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <DropdownMenu modal={false}>{t6}{t7}</DropdownMenu>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <div className="relative">{t3}{t8}</div>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}